import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	anErrorOccurred: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.error-boundary.an-error-occurred',
		defaultMessage: 'An error occurred',
		description: 'Message to display when an error occurs in a cell',
	},
});
